export const snackbarOpenedSelector = ({ notification }) => notification.snackbarOpened;
export const snackbarMessageSelector = ({ notification }) => notification.snackbarMessage;
export const snackbarTypeSelector = ({ notification }) => notification.snackbarType;
